import React from "react";
import styled from "styled-components";
// import Icon from "react-icons/lib/fa/angle-left";
import {Icon} from  "@vds/icons";

import { history } from "../../Layout/Layout";

import { media } from "utils/style";

const GoBack = ({ explicit, to, text, ...props }) => {
  const textFromAEM =
    window.landingPageJsonData &&
      window.landingPageJsonData.sections &&
      window.landingPageJsonData.sections[1] &&
      window.landingPageJsonData.sections[1].goBack
      ? window.landingPageJsonData.sections[1].goBack
      : text;
  return (
    <Button role="link" onClick={explicit ? () => history.push(to) : () => history.goBack()} {...props}>
      <Arrow name="left-arrow" focusable="false" style={{ fontSize: "24px" }} />
      {textFromAEM || "Go back"}
    </Button>
  );
};

export default GoBack;

const Button = styled.button`
  float: left;
  margin-left: 20px;
  margin-top: 80px;
  text-decoration: none;
  color: #000;
  padding: 1px 5px 0 0;
  background: 0;
  border: 0;
  font-size: 14px;
  line-height: 16px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  cursor: pointer;

  ${media.mobile`
    display: none;
  `}
`;

const Arrow = styled(Icon)`
  margin-right: 5px;
  margin-bottom: 4px;
`;
